import { render, staticRenderFns } from "./SettingsTabPrivacy.vue?vue&type=template&id=788579cc&"
import script from "./SettingsTabPrivacy.vue?vue&type=script&lang=js&"
export * from "./SettingsTabPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTabPrivacy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports